import PropTypes from "prop-types"
import React from "react"

const Stat = ({ label, children, detail }) => (
  <div className="min-w-0">
    <div className="text-sm text-gray-700">{label}</div>
    <div className="mt-1 whitespace-nowrap text-2xl font-bold text-gray-900">
      {children}
    </div>
    {detail && <div className="mt-1 text-sm text-gray-700">{detail}</div>}
  </div>
)

Stat.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  detail: PropTypes.string,
}

export default Stat
